import { encode as base64_encode } from "base-64";
import config from "../config";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import moment from "moment";
import utf8 from "utf8";

class DetailTrackingStore {
  total = 0;
  statusTotalCount = 0;
  loading = false;
  trackData = [];
  totalVehicalState = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      trackData: observable,
      loading: observable,
      loadData: action,
      total: observable,
      statusTotalCount: observable
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    status,
    driver,
    vehicleNo,
    searchField,
    isadmin,
    userCompany,
    userId
  }) {
    this.loading = true;
    var postData = {
      tokenId: "",
      searchField: searchField,
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      userCompany: userCompany,
      offset: offset,
      limit: limit,
      status: status,
      isDetailTracking: 1
    };
    const base64Input = await utf8.encode(JSON.stringify(postData));
    const base2 = JSON.stringify(base64_encode(base64Input));

    // const base64Input = await base64_encode(JSON.stringify(postData));
    if (config.pythonReport === 1) {

      var response = await postApi.getClient("").get(config.NodeUrl + "/DetailTracking/getDetailtrackDataByCH", { params: postData });  //current url
      //  var response = await postApi.getClient("").get("http://localhost:3043/DetailTracking/getDetailtrackDataByCH", { params: postData });
      var liveTrackingData = response?.data?.data?.detailtrack;

      let finalLiveTrackingData = await this.handleVehicleImageCH(liveTrackingData);
      this.trackData = finalLiveTrackingData;
      this.totalVehicalState = response?.data?.data?.totalvehstate;
      this.loading = false;

      this.total = parseInt(response?.data?.data?.TotalCount);
      this.statusTotalCount = this.totalVehicalState?.allStatusCount;
    }
    else {
      var response = await postApi.getClient().post("index.php?c=vehicletracking&a=detailtrackdata", "postData=" + base2);


      var liveTrackingData = response?.data?.data?.detailtrack;

      let finalLiveTrackingData = await this.handleVehicleImage(liveTrackingData);

      // Object.keys(liveTrackingData).map((e, i) => {
      //   let r = liveTrackingData[i];
      //   let defaultImage = "car-icon-blue.png";
      //   //  var diff = new Date(r.currtime) - new Date(r.updatedate);
      //   const diff = moment(r.currtime).diff(r.updatedate, "minutes");
      //   var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
      //   if (diff >= 90) {
      //     liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
      //     liveTrackingData[i].rowBackground = "gray";
      //     liveTrackingData[i].currentStatus = "nodata";
      //     defaultImage = "default-gray.png";
      //   } else if (r.acc == 1 && r.speed == 0) {
      //     //idle)
      //     liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
      //     liveTrackingData[i].rowBackground = "yellow";
      //     liveTrackingData[i].currentStatus = "idle";
      //     defaultImage = "default-yellow.png";
      //   } else if (
      //     r.acc == 0 ||
      //     r.acc == "NAA" ||
      //     r.acc == "NA" ||
      //     r.acc === null
      //   ) {
      //     liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
      //     liveTrackingData[i].rowBackground = "red";
      //     liveTrackingData[i].currentStatus = "stop";
      //     defaultImage = "default-red.png";
      //   } else if (r.acc == 1 && r.speed > 0) {
      //     liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
      //     liveTrackingData[i].rowBackground = "green";
      //     liveTrackingData[i].currentStatus = "running";
      //     defaultImage = "default-green.png";
      //   }
      //   liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

      //   try {
      //     require("../assets/images/detailtracking/" +
      //       liveTrackingData[i].listImage);
      //   } catch (err) {
      //     liveTrackingData[i].listImage = defaultImage;
      //   }

      //   try {
      //     require("../assets/images/livetracking/" +
      //       liveTrackingData[i].mapImage);
      //   } catch (err) {
      //     // console.log(defaultImage)
      //     // liveTrackingData[i].mapImage = "car-icon-blue.png";
      //     liveTrackingData[i].mapImage = defaultImage;
      //     // liveTrackingData[i].listImage =defaultImage
      //   }
      // });
      this.trackData = finalLiveTrackingData;
      this.totalVehicalState = response?.data?.data?.totalvehstate;
      this.loading = false;

      this.total = parseInt(response?.data?.data?.TotalCount);
      this.statusTotalCount = this.totalVehicalState?.allStatusCount;//response?.data?.data?.statusTotalCount;
    }
    // console.log(this.total, "total");
  }


  async handleVehicleImageCH(data) {
    let liveTrackingData = data;
    Object.keys(liveTrackingData).map((e, i) => {
      let r = liveTrackingData[i];
      var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
      let defaultImage = "car-icon-blue.png";
      if (r.vehicleStatus === "nodata") {
        liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
        liveTrackingData[i].rowBackground = "gray";
        liveTrackingData[i].currentStatus = "No Data";
        defaultImage = "default-gray.png";
      } else if (r.vehicleStatus === "idle") {
        //idle)
        liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
        liveTrackingData[i].rowBackground = "yellow";
        liveTrackingData[i].currentStatus = "Idle";
        defaultImage = "default-yellow.png";
      } else if (r.vehicleStatus === "stop") {
        liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
        liveTrackingData[i].rowBackground = "red";
        liveTrackingData[i].currentStatus = "Stopped";
        defaultImage = "default-red.png";
      } else if (r.vehicleStatus === "running") {
        liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
        liveTrackingData[i].rowBackground = "green";
        liveTrackingData[i].currentStatus = "Running";
        defaultImage = "default-green.png";
      }

      liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

      try {
        require("../assets/images/detailtracking/" +
          liveTrackingData[i].listImage);
      } catch (err) {
        liveTrackingData[i].listImage = defaultImage;
      }

      try {
        require("../assets/images/livetracking/" +
          liveTrackingData[i].mapImage);
      } catch (err) {
        liveTrackingData[i].mapImage = defaultImage; //"car-icon-blue.png";
      }
    });
    return liveTrackingData;
  }

  async handleVehicleImage(data) {
    let liveTrackingData = data;
    Object.keys(liveTrackingData).map((e, i) => {
      let r = liveTrackingData[i];

      //  var diff = new Date(r.currtime) - new Date(r.updatedate);
      const diff = moment(r.currtime).diff(r.updatedate, "minutes");

      var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
      let defaultImage = "car-icon-blue.png";
      if (diff >= 90) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
        liveTrackingData[i].rowBackground = "gray";
        liveTrackingData[i].currentStatus = "No Data";
        defaultImage = "default-gray.png";
      } else if (r.acc == 1 && r.speed == 0) {
        //idle)
        liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
        liveTrackingData[i].rowBackground = "yellow";
        liveTrackingData[i].currentStatus = "Idle";
        defaultImage = "default-yellow.png";
      } else if (r.acc == 0 ||
        r.acc == "NAA" ||
        r.acc == "NA" ||
        r.acc === null) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
        liveTrackingData[i].rowBackground = "red";
        liveTrackingData[i].currentStatus = "Stopped";
        defaultImage = "default-red.png";
      } else if (r.acc == null || (r.acc == 1 && r.speed > 0)) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
        liveTrackingData[i].rowBackground = "green";
        liveTrackingData[i].currentStatus = "Running";
        defaultImage = "default-green.png";
      }

      liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

      try {
        require("../assets/images/detailtracking/" +
          liveTrackingData[i].listImage);
      } catch (err) {
        liveTrackingData[i].listImage = defaultImage;
      }

      try {
        require("../assets/images/livetracking/" +
          liveTrackingData[i].mapImage);
      } catch (err) {
        liveTrackingData[i].mapImage = defaultImage; //"car-icon-blue.png";
      }
    });
    return liveTrackingData;
  }

  async exportExcel(postData) {
    // window.location.href = config.baseURL + "index.php?c=vehicle&a=exportloginexcel&cid=" +getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + '&uId=' + getDta.userid + '&colList=' + getDta.colList
    if (config.pythonReport === 1) {

      var detailTrackData = { postData };
      try {
        var response = await postApi.getClient("").post(config.NodeUrl + "/DetailTracking/exportDetailTrackingDataCH", detailTrackData, { responseType: "blob" });
        //var response = await postApi.getClient("NodeCoreUrl").post("DetailTracking/exportDetailTrackingData", detailTrackData, {responseType: "blob",});
        //var response = await postApi.getClient("").post("http://localhost:3059/DetailTracking/exportDetailTrackingData", detailTrackData, {responseType: "blob",});

        console.log(response, "response");
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Detail_Tracking_Excel.xlsx";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading the file", error);
      }

    }
    else {
      window.location.href =
        config.baseURL +
        "index.php?c=vehicletracking&a=exportDetailTrackingExcel&cid=" +
        postData.cid +
        // "&userCompanyId=" +
        // 1 +
        "&isadmin=" +
        postData.isadmin +
        "&userId=" +
        postData.userId +
        "&colList=" +
        postData.colList +
        "&searchField=" +
        postData.searchField +
        "&status=" +
        postData.status +
        "&userId=" +
        postData.userId;

    }



    // http://192.168.1.100:8088/awtl_react/app/index.php?c=vehicletracking&a=exportDetailTrackingExcel&cid=118&userCompanyId=1&isadmin=-1&colList=companyName,vehicleNo,rfid,vehicleTypeNew,name,formatted_address,acc,speed,updatedate,GPS,alert,distance,temp1,temp2,temp3,,&vehicleNo=&driver=&status=normal&userId=1
  }
}

export default DetailTrackingStore;
